<template>
  <div class="toolbar">
    <v-row justify="between">
      <h2 v-if="title" class="toolbar__title">{{ title }}</h2>
      <div v-if="hasDefaultSlot" class="toolbar__tools">
        <slot />
      </div>
    </v-row>

    <v-row v-if="hasSecondRow" justify="between">
      <div class="toolbar__tools">
        <slot name="secondRowToolsLeft" />
      </div>
      <div class="toolbar__tools">
        <slot name="secondRowToolsRight" />
      </div>
    </v-row>
  </div>
</template>

<script>
import VRow from '@/components/common/VRow.vue'

export default {
  name: 'VToolbar',
  props: {
    title: String
  },
  components: { VRow },
  computed: {
    hasDefaultSlot() {
      return this.$slots.default
    },
    hasSecondRow() {
      return this.$slots.secondRowToolsLeft || this.$slots.secondRowToolsRight
    }
  }
}
</script>

<style>
</style>
